<template>
  <q-no-ssr>
    <!-- Header Section -->
    <q-header class="bg-white q-pt-lg q-pb-lg">
      <q-toolbar class="container-global-header-footer">
        <div class="row justify-between items-center full-width">
          <div class="row justify-center items-center">
            <!-- Logo -->
            <img class="logo cursor-pointer" id="logo-global" loading="eager" src="../../assets/images/logo.svg"
              alt="اكواد أداة تقييم تجربة المستخدم" width="135" height="40" fetchpriority="high" role="link" @click="goToHomePage()" />

            <!-- Flag and Slogan -->
            <div class="q-ml-lg text-dark text-bolda dev-into-saudi ">
              <img class="flag" src="~assets/images/sa-flag.svg" alt="السعودية" width="32" height="32"
                title="طوِّر بفخر في السعودية" fetchpriority="high" />
              <span v-if="gtSixFourZero">
                طوِّر بفخر في <span class="text-green-8">السعودية</span>
              </span>
            </div>
          </div>


          <!-- Desktop Navigation -->
          <template v-if="gtOneTwoFourTwo">
            <div class="flex items-center col-grow justify-center">
              <span   tabindex="0"  role="link" :class="[centerItems[0].class, {
                'active-link': route.path === centerItems[0].to
              }]" @click="handleNavigation(centerItems[0].to)">
                {{ centerItems[0].label }}
              </span>
              <span   tabindex="0"  role="link" :class="[centerItems[1].class, {
                'active-link': route.path === centerItems[1].to
              }]" @click="handleNavigation(centerItems[1].to)">
                {{ centerItems[1].label }}
              </span>
              <q-btn-dropdown   role="button"  class="solution-btn text-neutral fs-md text-weight-bold" label="حلول أكواد"
                :ripple="false" icon="" dropdown-icon="icon-chevron-down" content-class="solution-btn-menu"
                aria-label="solution-btn">
                <q-list  role="list" class="drop_down_header">
                  <template v-for="(item, index) in centerItems" :key="index">
                    <q-item role="link"   clickable v-close-popup v-if="index > 1 && index < 7" :to="!item.external ? item.to : null"
                      :tag="item.external && !item.customClick ? 'a' : 'div'" :href="item.external && !item.customClick ? item.to : undefined" :target="item.external && !item.customClick ? '_blank' : ''"
                      @click="item.customClick ? handleCustomClick(item.to) : null">
                      <q-item-section>
                        <q-item-label :class="item.class">
                          {{ item.label }}
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>
                </q-list>
              </q-btn-dropdown>
              <span   tabindex="0"  role="link" :class="[centerItems[7].class, {
                'active-link': route.path === centerItems[7].to
              }]" @click="handleNavigation(centerItems[7].to)">
                {{ centerItems[7].label }}
              </span >
            </div>
            <div class="flex  justify-end items-center">
              <!-- <div style="width: 28%" class="q-mr-xl" v-if="route.path !== '/'">
                <HeaderSearchBar />
              </div> -->


              <div class="flex items-center">
                <!-- Chrome Extension Button -->
                <q-btn
                class="text-dark q-mx-md"
                label=""
                  style="padding-inline: 0px;"
                  icon="img:/chrome.store.svg"
                  type="a"
                  href="https://chromewebstore.google.com/detail/akwad-ux-tool/moimamimapjopaapamoiciljeocjfddl"
                />

                <!-- Unauthenticated Navigation -->
                <div v-if="!loggedIn">
                  <span v-for="item in unAuthNavItems" :key="item.label" :class="item.class"
                    @click="router.push(item.to)" style="cursor: pointer;">
                    {{ item.label }}
                    <q-icon v-if="item.icon" :name="item.icon" size="sm" class="q-mr-xs" />
                  </span>
                </div>

                <!-- Authenticated Navigation -->
                <template v-else>
                  <div class="flex q-gutter-sm">
                    <NotificationBtn />
                    <q-btn-dropdown role="button" class="user-btn text-neutral fs-sm" :label="userName" :ripple="false"
                      icon="icon-user-line" dropdown-icon="icon-chevron-down" content-class="user-btn-menu"
                      aria-label="user-btn">
                      <q-list role="list" class="drop_down_header">
                        <q-item role="link" v-for="item in filteredAuthNavItems" :key="item.label" clickable v-close-popup
                          :to="item.to" @click="item.click">
                          <q-item-section>
                            <q-item-label :class="item.class">
                              {{ item.label }}
                            </q-item-label>
                          </q-item-section>
                        </q-item>
                      </q-list>
                    </q-btn-dropdown>
                  </div>
                </template>

                <div class="header-segment-switch q-ml-md">
                  <button class="header-segment-switch-btn fs-sm"
                    :class="{ active: selectedHeaderToggle === 'SubscriptionPage' }"
                   role="button" @click="onHeaderToggle('SubscriptionPage')" aria-label="اطلب رأي خبير">
                    اطلب تقرير خبير
                  </button>
                  <button class="header-segment-switch-btn fs-md"
                  role="button"   :class="{ active: selectedHeaderToggle === 'ExpertPage' }" @click="onHeaderToggle('ExpertPage')"
                    aria-label="زد دخلك بالتقييم">
                    زد دخلك بالتقييم
                  </button>
                </div>
              </div>
            </div>
          </template>

          <!-- Mobile Navigation Toggle -->
          <template v-else>
            <div class="flex items-center justify-center">
              <NotificationBtn v-if="loggedIn" />
              <q-btn flat @click="drawer = !drawer" round dense icon="menu" color="primary" size="lg"
                aria-label="menu-btn" />
            </div>

          </template>

        </div>
      </q-toolbar>
    </q-header>
    <template v-if="shouldShowProfileSummary && loggedIn">
      <ProfileSummary :class="'profile-summary'"
       :full_total="userName" :country="authStore.getCountry() || 'لا دولة'" :show_icons="true"
        :is_verified="authStore.is_user_verified" :review_total="+review_total || 0"
        :review_views_total="+review_views_total || 0" :review_likes_total="+review_likes_total || 0" :loading="false"
        :is_owner="true" />
    </template>




    <!-- Mobile Drawer -->
    <q-drawer v-model="drawer" :breakpoint="1330" elevated class="bg-white q-pa-md">
      <q-scroll-area class="fit">
        <div class="q-pa-sm">
          <!-- Logo and Close Button -->
          <div class="row items-center justify-between">
            <q-img class="logo cursor-pointer" src="/logo.svg" alt="Akwadlogo" @click="goToHomePage" width="120px"
              height="auto" fit="contain" loading="lazy" />

            <q-icon name="close" size="sm" flat color="primary" class="cursor-pointer" @click="drawer = false" />
          </div>

          <!-- Drawer Navigation Items -->
          <q-list class="q-mt-lg" v-if="drawer">
            <q-item v-for="item in filteredDrawerNavItems" :key="item.id" clickable
              :to="!item.external ? (item.to == '/' ? { name: 'NewHomePage' } : item.to) : null"
              :tag="item.external && !('customClick' in item && item.customClick) ? 'a' : 'div'"
              :href="item.external && !('customClick' in item && item.customClick) ? item.to : undefined"
              :target="item.external && !('customClick' in item && item.customClick) ? '_blank' : ''"
              @click="'customClick' in item && item.customClick && item.to ? handleCustomClick(item.to) : item.click" >
              <q-item-section avatar>
                <span v-if="item.is_svg && item.is_svg === true" v-html="item.icon" text-color="primary"></span>
                <q-avatar v-else :icon="item.icon" text-color="primary" />
              </q-item-section>

              <q-item-section>
                <q-item-label class="akwad-medium text-dark text-body1">
                  {{ item.label }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </div>
      </q-scroll-area>
    </q-drawer>

    <!-- Logout Confirmation Dialog -->
    <q-dialog v-model="logoutDialog" position="standard" persistent>
      <q-card class="bg-slate-700 shadow-24" style="width: 650px; max-width: 90vw; padding: 5px">
        <q-card-section style="padding-top: 0">
          <div class="text-h6 akwad-medium">هل تريد تسجيل الخروج ؟</div>
        </q-card-section>

        <q-card-actions align="right" class="akwad-medium">
          <q-btn label="إلغاء" outline color="grey" v-close-popup icon-right="icon-x1" class="popup-btn"
            aria-label="cancel-btn" />
          <q-btn label="تأكيد" color="primary" @click="onLogout" icon-right="icon-check" class="popup-btn" icon-xs
            aria-label="confirm-btn" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-no-ssr>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { logout } from '@/services/auth-service';
import MyToaster from '@/utils/toaster';
import {
  useQuasar,
  QCard,
  QCardSection,
  QCardActions,
  QDialog,
  QNoSsr,
  QList,
  QToolbar,
  QHeader,
  QBtnDropdown,
  QBtn,
  QDrawer,
  QScrollArea,
  QAvatar,
  QIcon,
  QItem,
  QItemLabel,
  QItemSection,
} from 'quasar';
import HeaderSearchBar from './HeaderSearchBar.vue';
import NotificationBtn from '../notification/NotificationBtn.vue';
import ProfileSummary from '../profile/ProfileSummary.vue';


const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();

// Refs
const drawer = ref(false);
const logoutDialog = ref(false);

// Computed properties
const loggedIn = computed(() => authStore.isLoggedIn);
const userName = computed(() => `${authStore.user?.first_name} ${authStore.user?.last_name}`);
const gtSixFourZero = computed(() => $q.screen.width > 640);
const gtOneTwoFourTwo = computed(() => $q.screen.width > 1330);


const review_views_total = computed(() => authStore.getReviewViewsTotal());
const review_likes_total = computed(() => authStore.getReviewLikesTotal());
const review_total = computed(() => authStore.getReviewTotal());

const pagesToShowProfileSummary = ['BusinessProfilePage', 'ReviewProfilePage', 'ProfileSettingsPage', 'OrdersSubscriptionPage', 'SubscriptionPage', 'VerifiedReviewerEditPage',
 'VerifiedReviewerPage'
];

// Computed property to check if ProfileSummary should be shown
const shouldShowProfileSummary = computed(() => {
  return loggedIn.value && pagesToShowProfileSummary.includes(route.name as string);
});

// Navigation items
// const businessVerifyBtn = {
//   id: 'drawer-business-verify',
//   class: 'primary_btn rounded-8 business-btn text-bold',
//   label: 'للأعمـــــال',
//   icon: 'icon-briefcase1',
//   to: '/lab',
//   click: () => (drawer.value = false),
//   visible: true,
// };

const backendInsightBaseUrl = (import.meta.env.VITE_BACKEND_INSIGHT || 'http://localhost:8000').replace(/\/$/, '');
const backendInsightDashboardUrl = `${backendInsightBaseUrl}/dashboard`;

const centerItems = [
  {
    class: 'center_items fs-md text-weight-bold',
    label: 'الرئيسية',
    name: 'NewHomePage',
    to: '/',
  },
  {
    class: 'center_items fs-md text-weight-bold',
    label: 'عن الشركة',
    to: '/about-us',
  },
  {
    class: 'center_items fs-md text-weight-bold',
    label: 'الريت',
    name: 'HomePage',
    to: '/rating',
  },
  {
    class: 'center_items fs-md text-weight-bold',
    label: 'الأكسبرت',
    name: 'ExpertPage',
    to: '/expert',
  },
  {
    class: 'center_items fs-md text-weight-bold',
    label: 'مختبر أكواد',
    name: 'LabPage',
    to: '/lab',
  },
  {
    class: 'center_items fs-md text-weight-bold',
    label: 'أكواد إنسايت',
    name: 'أكواد إنسايت',
    to: backendInsightDashboardUrl,
    external: true,
    customClick: true,
  },
  {
    class: 'center_items fs-md text-weight-bold',
    label: ' حمل أداة اكواد ',
    name: 'downloadAkwdaToll',
    external: true,
    to: 'https://chromewebstore.google.com/detail/akwad-ux-tool/moimamimapjopaapamoiciljeocjfddl',
  }, {
    class: 'center_items fs-md text-weight-bold',
    label: 'اتصل بنا',
    name: 'ContactUsPage',
    to: '/contact-us',
  },

]



const unAuthNavItems = [
  {
    class: 'login-btn rounded-2  text-neutral   fs-md',
    label: '',
    icon: 'icon-user-line ',
    to: '/login',
  },
  {
    class: 'login-btn rounded-2  text-neutral  fs-md q-mx-sm ',
    label: 'تسجيل الدخول',
    icon: '',
    to: '/login',
  },

];

const authNavItems = computed(() => [
  {
    class: 'akwad-medium',
    label: 'الملف الشخصي',
    icon: '',
    to: `/${authStore.user?.slug}`,
    click: () => null,
    visible: loggedIn.value,
  },
  {
    class: 'akwad-medium',
    label: ' المحفظة',
    icon: '',
    to: '/wallet',
    click: () => null,
    visible: loggedIn.value ,
  },
  {
    class: 'akwad-medium',
    label: 'التقييمات',
    icon: '',
    to: '/reviews',
    click: () => null,
    visible: loggedIn.value,
  },
  {
    class: 'akwad-medium',
    label: 'ملف الأعمال',
    icon: '',
    to: '/business',
    click: () => null,
    visible: loggedIn.value && authStore.is_agent === 1,
  },

  // {
  //   class: '',
  //   label: 'طلب خدمة تقييم',
  //   icon: 'add_circle',
  //   to: '/subscription',
  //   click: () => (drawer.value = false),
  //   visible: () => loggedIn.value,
  // },
  {
    class: '',
    label: 'الطلبات',
    icon: '',
    to: '/orders-subscription',
    click: () => (drawer.value = false),
    visible: () => loggedIn.value,
  },
  {
    class: 'akwad-medium',
    label: ' انضم كمقيم معتمد',
    icon: '',
    to: '/verified-reviewer',
    click: () => null,
    visible: loggedIn.value && !authStore.is_user_verified,
  },
  {
    class: 'akwad-medium',
    label: 'الإعدادات',
    icon: '',
    to: '/settings',
    click: () => null,
    visible: loggedIn.value,
  },
  {
    class: 'akwad-medium',
    label: 'تسجيل الخروج',
    icon: '',
    to: null,
    click: () => (logoutDialog.value = true),
    visible: loggedIn.value,
  },
]);

const drawerNavItems = [

  {
    class: 'center_items fs-md text-bold',
    label: 'الرئيسية',
    icon: '<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 18.3333L6.50167 14.9983C6.50167 14.2225 6.50167 13.835 6.62917 13.5292C6.71293 13.3268 6.83575 13.143 6.9906 12.9881C7.14546 12.8332 7.32932 12.7104 7.53167 12.6267C7.8375 12.5 8.225 12.5 9 12.5C9.775 12.5 10.1633 12.5 10.47 12.6267C10.6723 12.7104 10.8562 12.8332 11.0111 12.9881C11.1659 13.143 11.2887 13.3268 11.3725 13.5292C11.5 13.8358 11.5 14.2233 11.5 15V18.3333" stroke="#4C4CFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.90667 3.96768L4.07333 4.61852C2.81 5.60518 2.1775 6.09852 1.83917 6.79352C1.5 7.48935 1.5 8.29268 1.5 9.89935V11.6427C1.5 14.796 1.5 16.3727 2.47667 17.3527C3.45333 18.3327 5.02417 18.3327 8.16667 18.3327H9.83333C12.9758 18.3327 14.5475 18.3327 15.5233 17.3527C16.4992 16.3727 16.5 14.796 16.5 11.6418V9.90018C16.5 8.29268 16.5 7.48935 16.1608 6.79352C15.8217 6.09852 15.19 5.60518 13.9267 4.61852L13.0933 3.96852C11.1267 2.43268 10.1433 1.66602 9 1.66602C7.85667 1.66602 6.87333 2.43268 4.90667 3.96768Z" stroke="#4C4CFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    to: '/',
    is_svg: true,
    visible: () => true,
  },
  {
    class: 'center_items fs-md text-bold',
    label: 'عن الشركة',
    icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.3337 18.3331H1.66699M11.667 7.49974H8.33366M11.667 12.4997H8.33366M5.41783 6.6664H5.41033M5.41866 9.99974H5.41033M5.41866 13.3331H5.41033M14.5845 6.6664H14.577M14.5853 9.99974H14.577M14.5853 13.3331H14.577M17.5003 6.23724C17.5003 5.32224 17.5003 4.86557 17.2703 4.4789C17.0403 4.09224 16.6162 3.84057 15.7687 3.33307L14.6903 2.68807C13.3595 1.8914 12.6937 1.49307 12.1803 1.73974C11.667 1.9864 11.667 2.7039 11.667 4.1389V18.3331H17.5003V6.23724ZM2.50033 6.23724C2.50033 5.32224 2.50033 4.86557 2.73033 4.4789C2.96033 4.09224 3.38449 3.84057 4.23199 3.33307L5.31033 2.68807C6.64199 1.89057 7.30699 1.4914 7.82033 1.7389C8.33366 1.9864 8.33366 2.7039 8.33366 4.1389V18.3331H2.50033V6.23724Z" stroke="#4C4CFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    to: '/about-us',
    is_svg: true,
    visible: () => true,

  },
  {
    class: 'center_items fs-md text-bold',
    label: 'الريت',
    icon: '<svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.9813 9.5678C16.9813 10.7938 16.9616 12.0198 16.9813 13.2458C17.011 14.3729 16.5072 15.154 15.5687 15.7175C13.5042 16.9435 11.4396 18.1695 9.41457 19.4449C8.24894 20.1766 7.15245 20.1766 5.98681 19.4944C4.63349 18.7133 3.27028 17.9322 1.87744 17.2302C0.603146 16.5777 0.0104487 15.5791 0.0104487 14.185C0.0104487 11.7331 0.0400836 9.28108 0.000570464 6.83898C-0.0191861 5.70198 0.474728 4.9209 1.40329 4.35734C3.56663 3.04237 5.72997 1.73728 7.89332 0.42231C8.94042 -0.220346 9.97764 -0.0720411 10.9951 0.481632C12.5164 1.32203 14.0277 2.1822 15.549 3.02259C16.5862 3.59604 16.9715 4.51553 16.9912 5.63277C17.011 6.94774 16.9912 8.25283 16.9912 9.5678H16.9813ZM5.17679 8.55932C5.17679 9.73588 5.2163 10.9223 5.16691 12.0989C5.13728 12.8206 5.43363 13.2062 6.04608 13.5226C7.42904 14.2444 8.79224 15.0254 10.1554 15.7867C11.3902 16.4689 11.9335 16.1822 11.9237 14.7387C11.9237 12.4251 11.8348 10.1116 11.815 7.79802C11.815 7.19492 11.5977 6.8291 11.0741 6.55226C9.57263 5.7613 8.10076 4.9209 6.59926 4.12994C5.57192 3.58615 5.19655 3.83333 5.17679 5.01977C5.15703 6.19633 5.17679 7.38277 5.17679 8.55932Z" fill="#5956F5"/></svg>',
    to: '/rating',
    is_svg: true,
    visible: () => true,
  },
  {
    class: 'center_items fs-md text-bold',
    label: 'الأكسبرت',
    icon: '<svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.9813 9.5678C16.9813 10.7938 16.9616 12.0198 16.9813 13.2458C17.011 14.3729 16.5072 15.154 15.5687 15.7175C13.5042 16.9435 11.4396 18.1695 9.41457 19.4449C8.24894 20.1766 7.15245 20.1766 5.98681 19.4944C4.63349 18.7133 3.27028 17.9322 1.87744 17.2302C0.603146 16.5777 0.0104487 15.5791 0.0104487 14.185C0.0104487 11.7331 0.0400836 9.28108 0.000570464 6.83898C-0.0191861 5.70198 0.474728 4.9209 1.40329 4.35734C3.56663 3.04237 5.72997 1.73728 7.89332 0.42231C8.94042 -0.220346 9.97764 -0.0720411 10.9951 0.481632C12.5164 1.32203 14.0277 2.1822 15.549 3.02259C16.5862 3.59604 16.9715 4.51553 16.9912 5.63277C17.011 6.94774 16.9912 8.25283 16.9912 9.5678H16.9813ZM5.17679 8.55932C5.17679 9.73588 5.2163 10.9223 5.16691 12.0989C5.13728 12.8206 5.43363 13.2062 6.04608 13.5226C7.42904 14.2444 8.79224 15.0254 10.1554 15.7867C11.3902 16.4689 11.9335 16.1822 11.9237 14.7387C11.9237 12.4251 11.8348 10.1116 11.815 7.79802C11.815 7.19492 11.5977 6.8291 11.0741 6.55226C9.57263 5.7613 8.10076 4.9209 6.59926 4.12994C5.57192 3.58615 5.19655 3.83333 5.17679 5.01977C5.15703 6.19633 5.17679 7.38277 5.17679 8.55932Z" fill="#5956F5"/></svg>',
    to: '/expert',
    is_svg: true,
    visible: () => true,
  },
  {
    class: 'center_items fs-md text-bold',
    label: 'مختبر أكواد',
    icon: '<svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.9813 9.5678C16.9813 10.7938 16.9616 12.0198 16.9813 13.2458C17.011 14.3729 16.5072 15.154 15.5687 15.7175C13.5042 16.9435 11.4396 18.1695 9.41457 19.4449C8.24894 20.1766 7.15245 20.1766 5.98681 19.4944C4.63349 18.7133 3.27028 17.9322 1.87744 17.2302C0.603146 16.5777 0.0104487 15.5791 0.0104487 14.185C0.0104487 11.7331 0.0400836 9.28108 0.000570464 6.83898C-0.0191861 5.70198 0.474728 4.9209 1.40329 4.35734C3.56663 3.04237 5.72997 1.73728 7.89332 0.42231C8.94042 -0.220346 9.97764 -0.0720411 10.9951 0.481632C12.5164 1.32203 14.0277 2.1822 15.549 3.02259C16.5862 3.59604 16.9715 4.51553 16.9912 5.63277C17.011 6.94774 16.9912 8.25283 16.9912 9.5678H16.9813ZM5.17679 8.55932C5.17679 9.73588 5.2163 10.9223 5.16691 12.0989C5.13728 12.8206 5.43363 13.2062 6.04608 13.5226C7.42904 14.2444 8.79224 15.0254 10.1554 15.7867C11.3902 16.4689 11.9335 16.1822 11.9237 14.7387C11.9237 12.4251 11.8348 10.1116 11.815 7.79802C11.815 7.19492 11.5977 6.8291 11.0741 6.55226C9.57263 5.7613 8.10076 4.9209 6.59926 4.12994C5.57192 3.58615 5.19655 3.83333 5.17679 5.01977C5.15703 6.19633 5.17679 7.38277 5.17679 8.55932Z" fill="#5956F5"/></svg>',
    to: '/lab',
    is_svg: true,
    visible: () => true,
  },
  {
    class:  'center_items fs-md text-bold',
    label: 'akwad insight',
    icon: '<svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.9813 9.5678C16.9813 10.7938 16.9616 12.0198 16.9813 13.2458C17.011 14.3729 16.5072 15.154 15.5687 15.7175C13.5042 16.9435 11.4396 18.1695 9.41457 19.4449C8.24894 20.1766 7.15245 20.1766 5.98681 19.4944C4.63349 18.7133 3.27028 17.9322 1.87744 17.2302C0.603146 16.5777 0.0104487 15.5791 0.0104487 14.185C0.0104487 11.7331 0.0400836 9.28108 0.000570464 6.83898C-0.0191861 5.70198 0.474728 4.9209 1.40329 4.35734C3.56663 3.04237 5.72997 1.73728 7.89332 0.42231C8.94042 -0.220346 9.97764 -0.0720411 10.9951 0.481632C12.5164 1.32203 14.0277 2.1822 15.549 3.02259C16.5862 3.59604 16.9715 4.51553 16.9912 5.63277C17.011 6.94774 16.9912 8.25283 16.9912 9.5678H16.9813ZM5.17679 8.55932C5.17679 9.73588 5.2163 10.9223 5.16691 12.0989C5.13728 12.8206 5.43363 13.2062 6.04608 13.5226C7.42904 14.2444 8.79224 15.0254 10.1554 15.7867C11.3902 16.4689 11.9335 16.1822 11.9237 14.7387C11.9237 12.4251 11.8348 10.1116 11.815 7.79802C11.815 7.19492 11.5977 6.8291 11.0741 6.55226C9.57263 5.7613 8.10076 4.9209 6.59926 4.12994C5.57192 3.58615 5.19655 3.83333 5.17679 5.01977C5.15703 6.19633 5.17679 7.38277 5.17679 8.55932Z" fill="#5956F5"/></svg>',
    to: backendInsightDashboardUrl,
    external: true,
    is_svg: true,
    visible: () => true,
  },
  // {
  //   class: 'center_items fs-md text-bold',
  //   label: 'حمل أداة اكواد ',
    
  //   icon: 'img:/chrome.store.svg',
  //   to: 'https://chromewebstore.google.com/detail/akwad-ux-tool/moimamimapjopaapamoiciljeocjfddl',
  //   // is_svg: true,
  //   visible: () => true,
  // },

  {
    class: 'akwad-medium',
    label: 'الملف الشخصي',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.75 7.5C7.75264 8.62636 8.20126 9.70583 8.99771 10.5023C9.79417 11.2987 10.8736 11.7474 12 11.75C13.1264 11.7474 14.2058 11.2987 15.0023 10.5023C15.7987 9.70583 16.2474 8.62636 16.25 7.5C16.2474 6.37364 15.7987 5.29417 15.0023 4.49771C14.2058 3.70126 13.1264 3.25264 12 3.25C10.8736 3.25264 9.79417 3.70126 8.99771 4.49771C8.20126 5.29417 7.75264 6.37364 7.75 7.5ZM9.25 7.5C9.25 5.98 10.48 4.75 12 4.75C13.52 4.75 14.75 5.98 14.75 7.5C14.75 9.02 13.52 10.25 12 10.25C10.48 10.25 9.25 9.02 9.25 7.5ZM17.75 20C17.75 20.41 18.09 20.75 18.5 20.75C18.91 20.75 19.25 20.41 19.25 20V17.97C19.25 16.32 18.44 14.91 17.12 14.31C14.05 12.93 9.96 12.92 6.88 14.31C5.56 14.91 4.75 16.31 4.75 17.97V20C4.75 20.41 5.09 20.75 5.5 20.75C5.91 20.75 6.25 20.41 6.25 20V17.97C6.25 17.13 6.58 16.09 7.5 15.67C10.19 14.46 13.82 14.46 16.5 15.67C17.42 16.1 17.75 17.14 17.75 17.97V20Z" fill="#5854FF"/></svg>',
    is_svg: true,
    to: `/${authStore.user?.slug}`,
    click: () => null,
    visible: () => loggedIn.value,
  },
  {
    class: 'akwad-medium',
    label: ' المحفظة',
    icon: '<svg width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.02891 1.75H4.97391C4.05391 1.75 3.32891 1.75 2.75891 1.825C2.17391 1.905 1.69891 2.07 1.32391 2.445C0.948906 2.82 0.783906 3.295 0.703906 3.88C0.658906 4.215 0.638906 4.61 0.633906 5.06C0.633906 5.085 0.628906 5.105 0.628906 5.125V6.155C0.628906 7.07 0.628906 7.8 0.703906 8.37C0.783906 8.955 0.948906 9.43 1.32391 9.805C1.69891 10.18 2.17391 10.345 2.75891 10.425C3.32891 10.5 4.05391 10.5 4.97391 10.5H7.02891C7.94891 10.5 8.67391 10.5 9.24391 10.425C9.82891 10.345 10.3039 10.18 10.6789 9.805C11.0539 9.43 11.2189 8.955 11.2989 8.37C11.3739 7.8 11.3739 7.07 11.3739 6.155V5.125C11.3739 5.105 11.3739 5.085 11.3689 5.06C11.3589 4.61 11.3439 4.215 11.2989 3.88C11.2189 3.295 11.0539 2.82 10.6789 2.445C10.3039 2.07 9.82891 1.905 9.24391 1.825C8.67391 1.75 7.94891 1.75 7.02891 1.75ZM10.6089 4.75C10.5989 4.455 10.5839 4.205 10.5539 3.98C10.4839 3.475 10.3589 3.19 10.1489 2.975C9.93891 2.765 9.64891 2.64 9.14391 2.57C8.62891 2.5 7.95391 2.5 6.99891 2.5H4.99891C4.04391 2.5 3.36891 2.5 2.85391 2.57C2.34891 2.64 2.05891 2.765 1.84891 2.975C1.63891 3.19 1.50891 3.475 1.44391 3.98C1.41391 4.205 1.39891 4.455 1.38891 4.75H3.15391C3.45891 4.75 3.69891 4.75 3.91891 4.825C4.05391 4.875 4.17891 4.94 4.29391 5.03C4.47891 5.17 4.61391 5.37 4.78391 5.625L4.81391 5.665C5.02891 5.985 5.08891 6.07 5.15891 6.125C5.20891 6.165 5.26891 6.195 5.32891 6.215C5.41391 6.245 5.51891 6.25 5.89891 6.25H6.09391C6.47891 6.25 6.57891 6.245 6.66391 6.215C6.72391 6.195 6.78391 6.165 6.83391 6.125C6.90891 6.07 6.96891 5.985 7.17891 5.665L7.20891 5.625C7.37891 5.37 7.50891 5.17 7.69891 5.03C7.81391 4.94 7.93891 4.875 8.07391 4.825C8.29391 4.75 8.53391 4.75 8.83891 4.75H10.6089ZM1.37391 5.5V6.125C1.37391 7.08 1.37391 7.755 1.44391 8.27C1.51391 8.775 1.63891 9.06 1.84891 9.275C2.05891 9.485 2.34891 9.61 2.85391 9.68C3.36891 9.75 4.04391 9.75 4.99891 9.75H6.99891C7.95391 9.75 8.62891 9.75 9.14391 9.68C9.64891 9.61 9.93891 9.485 10.1489 9.275C10.3589 9.06 10.4889 8.775 10.5539 8.27C10.6239 7.755 10.6239 7.08 10.6239 6.125V5.5H8.89891C8.51391 5.5 8.41391 5.505 8.32891 5.535C8.26891 5.555 8.20891 5.585 8.15891 5.625C8.08391 5.68 8.02391 5.765 7.81391 6.085L7.78391 6.13C7.61391 6.38 7.48391 6.58 7.29391 6.725C7.17891 6.81 7.05391 6.875 6.91891 6.925C6.69891 7 6.45891 7 6.15391 7H5.84891C5.54391 7 5.30391 7 5.08391 6.925C4.94891 6.875 4.82391 6.81 4.70891 6.725C4.52391 6.58 4.38891 6.38 4.21891 6.13L4.18891 6.085C3.97391 5.765 3.91391 5.68 3.84391 5.625C3.79391 5.585 3.73391 5.555 3.67391 5.535C3.58891 5.505 3.48391 5.5 3.10391 5.5H1.37391Z" fill="#4C4CFF"/></svg>',
    is_svg: true,
    to: '/wallet',
    click: () => null,
    visible: () => loggedIn.value,
  },
  // {
  //   ...businessVerifyBtn,
  //   click: () => (drawer.value = false),
  // },

  {
    id: 'drawer-ratings',
    class: '',
    label: 'التقييمات',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7272 3.44375L15.4872 6.99275C15.7272 7.48675 16.3672 7.96075 16.9072 8.05075L20.0962 8.58575C22.1362 8.92875 22.6162 10.4207 21.1462 11.8927L18.6662 14.3927C18.2462 14.8157 18.0162 15.6328 18.1462 16.2178L18.8562 19.3127C19.4162 21.7627 18.1262 22.7098 15.9762 21.4298L12.9862 19.6448C12.4462 19.3228 11.5562 19.3228 11.0062 19.6448L8.01822 21.4298C5.87822 22.7098 4.57822 21.7517 5.13822 19.3127L5.84822 16.2178C5.97822 15.6328 5.74822 14.8157 5.32822 14.3927L2.84822 11.8927C1.38922 10.4197 1.85922 8.92875 3.89822 8.58575L7.08822 8.05075C7.61822 7.96075 8.25822 7.48675 8.49822 6.99275L10.2582 3.44375C11.2182 1.51875 12.7782 1.51875 13.7282 3.44375" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    is_svg: true,

    to: '/reviews',
    click: () => (drawer.value = false),
    visible: () => loggedIn.value,
  },
  {
    id: 'drawer-business',
    class: 'icon-users',
    label: 'ملف الأعمال',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.007 21H9.605C6.02 21 4.228 21 3.114 19.865C2 18.73 2 16.903 2 13.25C2 9.597 2 7.77 3.114 6.635C4.228 5.5 6.02 5.5 9.605 5.5H13.408C16.993 5.5 18.786 5.5 19.9 6.635C20.757 7.508 20.954 8.791 21 11" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 5.5L15.9 5.19C15.405 3.65 15.158 2.88 14.569 2.44C13.979 2 13.197 2 11.63 2H11.367C9.802 2 9.019 2 8.43 2.44C7.84 2.88 7.593 3.65 7.098 5.19L7 5.5M17.111 13.255C17.296 13.085 17.388 13 17.5 13C17.612 13 17.704 13.085 17.889 13.255L18.602 13.912C18.688 13.991 18.731 14.031 18.784 14.05C18.838 14.07 18.896 14.068 19.014 14.063L19.976 14.025C20.224 14.015 20.348 14.011 20.433 14.082C20.518 14.153 20.535 14.276 20.568 14.522L20.7 15.508C20.716 15.622 20.723 15.678 20.751 15.728C20.779 15.776 20.824 15.811 20.914 15.882L21.69 16.492C21.882 16.644 21.978 16.719 21.997 16.827C22.016 16.935 21.951 17.039 21.823 17.247L21.297 18.094C21.237 18.191 21.207 18.24 21.197 18.294C21.187 18.348 21.199 18.405 21.223 18.517L21.432 19.495C21.482 19.735 21.508 19.855 21.453 19.951C21.398 20.047 21.281 20.085 21.048 20.161L20.122 20.462C20.012 20.498 19.956 20.516 19.913 20.552C19.87 20.589 19.843 20.641 19.79 20.744L19.338 21.615C19.223 21.838 19.165 21.949 19.06 21.987C18.955 22.025 18.84 21.977 18.608 21.881L17.72 21.513C17.611 21.468 17.557 21.445 17.5 21.445C17.443 21.445 17.389 21.468 17.28 21.513L16.392 21.881C16.16 21.977 16.045 22.025 15.94 21.987C15.835 21.949 15.777 21.837 15.662 21.615L15.21 20.744C15.156 20.641 15.13 20.589 15.087 20.553C15.044 20.517 14.988 20.498 14.878 20.463L13.952 20.161C13.719 20.085 13.602 20.047 13.547 19.951C13.492 19.855 13.517 19.736 13.568 19.495L13.778 18.517C13.801 18.405 13.813 18.349 13.803 18.295C13.7825 18.2227 13.7486 18.1548 13.703 18.095L13.178 17.247C13.048 17.039 12.984 16.935 13.003 16.827C13.022 16.719 13.118 16.644 13.31 16.493L14.086 15.883C14.176 15.811 14.221 15.776 14.249 15.727C14.277 15.678 14.284 15.622 14.299 15.507L14.432 14.522C14.465 14.277 14.482 14.153 14.567 14.082C14.652 14.011 14.776 14.015 15.024 14.025L15.987 14.063C16.104 14.068 16.162 14.07 16.216 14.05C16.269 14.03 16.312 13.991 16.398 13.912L17.111 13.255Z" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    is_svg: true,

    to: '/business',
    click: () => (drawer.value = false),
    visible: () => loggedIn.value && authStore.is_agent === 1,
  },
  {
    class: 'fs-md',
    label: 'طلب خدمة تقييم',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V16M16 12H8M2.5 12C2.5 7.522 2.5 5.282 3.891 3.891C5.282 2.5 7.521 2.5 12 2.5C16.478 2.5 18.718 2.5 20.109 3.891C21.5 5.282 21.5 7.521 21.5 12C21.5 16.478 21.5 18.718 20.109 20.109C18.718 21.5 16.479 21.5 12 21.5C7.522 21.5 5.282 21.5 3.891 20.109C2.5 18.718 2.5 16.479 2.5 12Z" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    is_svg: true,

    to: '/subscription',
    click: () => (drawer.value = false),
    visible: () => true,
  },
  {
    class: '',
    label: 'الطلبات',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 12C2.5 7.522 2.5 5.282 3.891 3.891C5.282 2.5 7.521 2.5 12 2.5C16.478 2.5 18.718 2.5 20.109 3.891C21.5 5.282 21.5 7.521 21.5 12C21.5 16.478 21.5 18.718 20.109 20.109C18.718 21.5 16.479 21.5 12 21.5C7.522 21.5 5.282 21.5 3.891 20.109C2.5 18.718 2.5 16.479 2.5 12Z" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 7.5H17M11 12H17M11 16.5H17M8 7.5C8 7.63261 7.94732 7.75979 7.85355 7.85355C7.75979 7.94732 7.63261 8 7.5 8C7.36739 8 7.24021 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24021 7.05268 7.36739 7 7.5 7C7.63261 7 7.75979 7.05268 7.85355 7.14645C7.94732 7.24021 8 7.36739 8 7.5ZM8 12C8 12.1326 7.94732 12.2598 7.85355 12.3536C7.75979 12.4473 7.63261 12.5 7.5 12.5C7.36739 12.5 7.24021 12.4473 7.14645 12.3536C7.05268 12.2598 7 12.1326 7 12C7 11.8674 7.05268 11.7402 7.14645 11.6464C7.24021 11.5527 7.36739 11.5 7.5 11.5C7.63261 11.5 7.75979 11.5527 7.85355 11.6464C7.94732 11.7402 8 11.8674 8 12ZM8 16.5C8 16.6326 7.94732 16.7598 7.85355 16.8536C7.75979 16.9473 7.63261 17 7.5 17C7.36739 17 7.24021 16.9473 7.14645 16.8536C7.05268 16.7598 7 16.6326 7 16.5C7 16.3674 7.05268 16.2402 7.14645 16.1464C7.24021 16.0527 7.36739 16 7.5 16C7.63261 16 7.75979 16.0527 7.85355 16.1464C7.94732 16.2402 8 16.3674 8 16.5Z" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    is_svg: true,

    to: '/orders-subscription',
    click: () => (drawer.value = false),
    visible: () => true,
  },
  {
    class: 'akwad-medium',
    label: ' إنضم كمقيم معتمد',
    icon: 'diversity_3',
    to: '/verified-reviewer',
    click: () => null,
    visible: () => loggedIn.value && !authStore.is_user_verified,
  },
  {
    id: 'drawer-settings',
    class: '',
    label: 'الإعدادات',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 12C15.5 12.4596 15.4095 12.9148 15.2336 13.3394C15.0577 13.764 14.7999 14.1499 14.4749 14.4749C14.1499 14.7999 13.764 15.0577 13.3394 15.2336C12.9148 15.4095 12.4596 15.5 12 15.5C11.5404 15.5 11.0852 15.4095 10.6606 15.2336C10.236 15.0577 9.85013 14.7999 9.52513 14.4749C9.20012 14.1499 8.94231 13.764 8.76642 13.3394C8.59053 12.9148 8.5 12.4596 8.5 12C8.5 11.0717 8.86875 10.1815 9.52513 9.52513C10.1815 8.86875 11.0717 8.5 12 8.5C12.9283 8.5 13.8185 8.86875 14.4749 9.52513C15.1313 10.1815 15.5 11.0717 15.5 12Z" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.011 14.0971C21.533 13.9561 21.794 13.8851 21.897 13.7511C22 13.6161 22 13.4001 22 12.9671V11.0331C22 10.6001 22 10.3831 21.897 10.2491C21.794 10.1151 21.533 10.0441 21.011 9.90408C19.061 9.37808 17.84 7.33908 18.343 5.40108C18.482 4.86808 18.551 4.60108 18.485 4.44508C18.419 4.28908 18.229 4.18108 17.85 3.96608L16.125 2.98608C15.753 2.77608 15.567 2.67008 15.4 2.69208C15.233 2.71408 15.044 2.90208 14.667 3.27908C13.208 4.73408 10.794 4.73408 9.334 3.27908C8.957 2.90308 8.769 2.71508 8.602 2.69208C8.435 2.67008 8.249 2.77508 7.877 2.98708L6.152 3.96608C5.772 4.18108 5.582 4.28908 5.517 4.44608C5.451 4.60108 5.52 4.86808 5.658 5.40108C6.161 7.33908 4.94 9.37808 2.989 9.90408C2.467 10.0441 2.206 10.1141 2.103 10.2491C2 10.3841 2 10.6001 2 11.0331V12.9671C2 13.4001 2 13.6171 2.103 13.7511C2.206 13.8851 2.467 13.9561 2.989 14.0971C4.939 14.6231 6.16 16.6621 5.657 18.5991C5.518 19.1321 5.449 19.3991 5.515 19.5551C5.581 19.7111 5.771 19.8191 6.15 20.0351L7.875 21.0131C8.247 21.2251 8.433 21.3301 8.6 21.3081C8.767 21.2861 8.956 21.0981 9.333 20.7211C10.793 19.2641 13.209 19.2641 14.669 20.7211C15.046 21.0971 15.234 21.2851 15.401 21.3081C15.568 21.3301 15.754 21.2251 16.127 21.0131L17.851 20.0341C18.231 19.8191 18.421 19.7111 18.486 19.5541C18.551 19.3971 18.483 19.1321 18.345 18.5991C17.841 16.6621 19.061 14.6231 21.011 14.0971Z" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    is_svg: true,

    to: '/settings',
    click: () => (drawer.value = false),
    visible: () => loggedIn.value,
  },
  {
    id: 'drawer-login',
    class: '',
    label: 'تسجيل الدخول',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 3L9.337 3.234C6.759 4.144 5.469 4.599 4.735 5.637C4.001 6.675 4 8.043 4 10.777V13.222C4 15.957 4 17.324 4.735 18.362C5.469 19.401 6.759 19.856 9.337 20.766L10 21M10 12H20M10 12C10 11.3 11.994 9.992 12.5 9.5M10 12C10 12.7 11.994 14.008 12.5 14.5" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    is_svg: true,
    to: '/login',
    click: () => (drawer.value = false),
    visible: () => !loggedIn.value,
  },
  {
    id: 'drawer-logout',
    class: '',
    label: 'تسجيل الخروج',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 3L10.337 3.234C7.759 4.144 6.469 4.599 5.735 5.637C5.001 6.675 5 8.043 5 10.777V13.222C5 15.957 5 17.324 5.735 18.362C6.469 19.401 7.759 19.856 10.337 20.766L11 21M21 12H11M21 12C21 11.3 19.006 9.992 18.5 9.5M21 12C21 12.7 19.006 14.008 18.5 14.5" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    is_svg: true,
    to: null,
    click: () => (logoutDialog.value = true),
    visible: () => loggedIn.value,
  },
];

// Filtered navigation items
const filteredAuthNavItems = computed(() =>
  authNavItems.value.filter(item => item.visible)
);

const filteredDrawerNavItems = computed(() =>
  drawerNavItems.filter(item =>
    typeof item.visible === 'function' ? item.visible() : item.visible
  )
);
// Methods
const handleNavigation = (to: any) => {
  if (typeof to === 'string') {
    router.push(to);
  } else if (to && to.hash) {
    // Handle hash navigation
    if (to.name === 'NewHomePage' && route.name === 'NewHomePage') {
      // If we're already on the home page, just scroll to the hash
      setTimeout(() => {
        const element = document.getElementById(to.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Navigate to the page with hash
      router.push(to);
    }
  } else {
    router.push(to);
  }
};

const goToHomePage = () => {
  router.push({ name: 'NewHomePage' });
  drawer.value = false;
};

const handleCustomClick = (url: string) => {
  // Get token from localStorage
  const authData = $q.localStorage.getItem('auth');
  let token = '';
  
  if (authData) {
    try {
      const parsed = typeof authData === 'string' ? JSON.parse(authData) : authData;
      token = parsed.token || '';
    } catch (e) {
      console.error('Error parsing auth data:', e);
    }
  }
  
  // Open URL with token in new tab
  const finalUrl = token ? `${url}?token=${token}` : url;
  window.open(finalUrl, '_blank');
};

const onLogout = async () => {
  try {
    await logout();
    authStore.logout();
    router.push('/');
    drawer.value = false;
    logoutDialog.value = false;
    const onBoard = $q.localStorage.getItem('onBoard');
    $q.localStorage.clear();
    if(onBoard &&  onBoard != null) {
      $q.localStorage.set('onBoard' , onBoard )
    }
    MyToaster.success('تم تسجل الخروج بنجاح');
  } catch (error) {
    authStore.logout();
    router.push('/');
    drawer.value = false;
    logoutDialog.value = false;
    MyToaster.success('تم تسجل الخروج بنجاح');
  }
};

// Segmented header switch state and navigation
type HeaderToggle = 'ExpertPage' | 'SubscriptionPage';
const selectedHeaderToggle = ref<HeaderToggle | null>(
  route.name === 'ExpertPage' ? 'ExpertPage' : 'SubscriptionPage'
);

const onHeaderToggle = (value: HeaderToggle) => {
  selectedHeaderToggle.value = value;
  if (value === 'SubscriptionPage') {
    router.push('/subscription');
  } else {
    router.push('/expert');
  }
};

watch(
  () => route.path,
  (newPath) => {
    if (newPath === '/expert') selectedHeaderToggle.value = 'ExpertPage';
    else selectedHeaderToggle.value = 'SubscriptionPage';
  }
);
</script>

<style scoped lang="scss">
.text-bold {
  // font-weight: 600;
}

.active-link {
  color: #5854ff !important;
  // font-weight: 600;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
    width: 70%;
    height: 2px;
    background: #5854ff;
    border-radius: 1px;
  }
}

.center_items {
  transition: all 0.3s ease;

  &:hover {
    color: #5854ff;
  }
}

.text-neutral {
  color: #333;
}

.header-segment-switch {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px;
  border: 1px solid #e2e1ff;
  border-radius: 999px;
  background-color: #ffffff;
}

.header-segment-switch-btn {
  border: none;
  background: transparent;
  color: #5854ff;
  padding: 8px 18px 10px;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 600;
  line-height: 1;
}

.header-segment-switch-btn.active {
  background-color: #5854ff;
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(88, 84, 255, 0.25);
}
</style>


<style>
.q-menu.q-position-engine.scroll.user-btn-menu,
.q-menu.q-position-engine.scroll.solution-btn-menu {
  border-radius: 20px;
  padding: 8px;
  /* border: 1px solid #0000001c */
  ;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

.q-item.q-item-type.row.no-wrap.q-item--clickable.q-link.cursor-pointer.q-focusable.q-hoverable,
.q-item.q-item-type.row.no-wrap.q-item--clickable.q-link.cursor-pointer.q-focusable.q-hoverable {
  border-radius: 10px;

}

.solution-btn .q-icon.on-left {
  width: 3px;
}

.solution-btn .icon-chevron-down {
  margin-right: 15px;
  font-size: 24px;
}

.q-focusable:focus>.q-focus-helper,
.q-manual-focusable--focused>.q-focus-helper,
.q-hoverable:hover>.q-focus-helper {
  background: #00000001 !important;
  opacity: 1 !important;
}

.q-focusable:focus>.q-focus-helper,
.q-manual-focusable--focused>.q-focus-helper,
.q-hoverable:hover .q-item__label {
  color: #000000 !important;
}

.dev-into-saudi {
  width: 170px;

  @media (max-width: 768px) {
    width: 60px;
  }
}
</style>